"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LowestValueComposer = void 0;
var LowestValueComposer = /** @class */ (function () {
    function LowestValueComposer() {
    }
    LowestValueComposer.prototype.compose = function () {
        var vals = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            vals[_i] = arguments[_i];
        }
        var numbers = vals.filter(function (v) { return v !== undefined; });
        return Math.min.apply(Math, numbers);
    };
    return LowestValueComposer;
}());
exports.LowestValueComposer = LowestValueComposer;
